import { UnryoIssue } from '@/model/node'

export function findMostImportantIssue (...issues: any[]): UnryoIssue | undefined {
  let mostImportantIssue
  for (const issue of issues) {
    if (issue && (!mostImportantIssue || issue.severity < mostImportantIssue.severity)) {
      mostImportantIssue = issue
    }
  }
  return mostImportantIssue
}
